import { render, staticRenderFns } from "./languages.html?vue&type=template&id=5dada95e&scoped=true&"
import script from "./languages.vue?vue&type=script&lang=js&"
export * from "./languages.vue?vue&type=script&lang=js&"
import style0 from "./languages.vue?vue&type=style&index=0&id=5dada95e&scoped=true&lang=css&"
import style1 from "./languages.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dada95e",
  null
  
)

export default component.exports